import { Button } from 'primereact/button';
import { Head } from 'components/head/Head';
import { OrderType } from 'types';
import { ReactElement, useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useCartContext } from 'CartContext';
import { useGetUserOrders, useLogin } from 'hooks/userHooks';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import DigitalContent from 'components/DigitalContent';
import DigitalProductList from 'components/DigitalProductList';
import Footer from 'components/footer-crwd/Footer';
import Nav from 'components/nav/Nav';
import Order from 'components/Order';
import Spinner from 'components/Spinner';
import './OrdersAndDC.scss';

export default function OrdersAndDC(): ReactElement {
  const { orders, fetching } = useGetUserOrders();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(
    location.pathname === '/orders' ? 0 : 1,
  );
  const navigate = useNavigate();
  const { productSku } = useParams();
  const { loggedInUserId, userInfo } = useCartContext();
  const login = useLogin();

  useEffect(() => {
    if (productSku) {
      setActiveIndex(1);
    }
  }, [productSku]);

  useEffect(() => {
    if (location.pathname.includes('/digital-content') && !activeIndex) {
      setActiveIndex(1);
    }
  }, [activeIndex, location.pathname]);

  const onTabChangeHandle = (e: any) => {
    setActiveIndex(e.index);
    navigate(e.index ? '/digital-content' : '/orders');
  };

  function Digital(): ReactElement {
    if (fetching) {
      return <Spinner />;
    }
    if (productSku) {
      return <DigitalContent />;
    }
    if (orders) {
      return <DigitalProductList orders={orders} />;
    }
    return <></>;
  }

  return (
    <>
      <Head
        title={activeIndex === 0 ? 'Orders' : 'Digital Content'}
        link={activeIndex === 0 ? '/orders' : '/digital-content'}
        twitterUsername="@advancedmedmkt"
        addPostfixTitle
      />
      <Nav />
      <div
        className="orders"
        style={{ maxWidth: '1140px', margin: '2rem auto' }}
      >
        {loggedInUserId && userInfo ? (
          <TabView
            activeIndex={activeIndex}
            onTabChange={e => onTabChangeHandle(e)}
          >
            <TabPanel header="Orders">
              {fetching ? (
                <Spinner />
              ) : (
                orders
                  ?.sort((a: any, b: any) => b.increment_id - a.increment_id)
                  ?.map((order: any) => (
                    <Order
                      key={order.increment_id}
                      orderData={order as any as OrderType}
                    />
                  )) || <div>No orders found.</div>
              )}
            </TabPanel>
            <TabPanel header="Digital Content">
              <Digital />
            </TabPanel>
          </TabView>
        ) : (
          <div
            className="flex flex-column align-items-center justify-content-center"
            style={{ height: '200px' }}
          >
            <p>You have to login to view this page</p>
            <Button
              className="uppercase border-noround c-button-primary mx-auto"
              label="Login"
              onClick={login}
            />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
